import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/auth/Login'
import Admin from '../views/Admin'

Vue.use(VueRouter)

const routes = [
			{
				path: '/login',
				name: 'login',
				component: Login
			},
			{
			path: '/admin',
			name: 'admin',
			component: Admin,
			children: [
			// Dashboard Route
			{
				path: '/dashboard',
				name: 'dashboard',
				component: () => import('../views/Dashboard'),
			},
			// Setting Route
			{
				path: '/setting',
				name: 'setting',
				component: () => import('../views/setting/settingView'),
			},
			// Account Routes
			{
				path: '/account-list',
				name: 'account-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/account/accountList'),
			},
			// Student Routes
			{
				path: '/student-list',
				name: 'student-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/account/studentList'),
			},
			{
				path: '/account-create',
				name: 'account-create',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/account/accountCreate'),
			},
			{
				path: '/account-edit',
				name: 'account-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/account/accountEdit'),
			},
			// Dsicount Routes
			{
				path: '/discount-list',
				name: 'discount-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/discount/discountList'),
			},
			{
				path: '/discount-create',
				name: 'discount-create',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/discount/discountCreate'),
			},
			{
				path: '/discount-edit',
				name: 'discount-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/discount/discountEdit'),
			},
			{
				path: '/discount-alias-edit',
				name: 'discount-alias-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/discount/discountAliasEdit'),
			},
			// Batch Routes
			{
				path: '/batch-list',
				name: 'batch-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/batch/batchList'),
			},
			{
				path: '/batch-create',
				name: 'batch-create',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/batch/batchCreate'),
			},
			{
				path: '/batch-edit',
				name: 'batch-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/batch/batchEdit'),
			},
			{
				path: '/batch-alias-edit',
				name: 'batch-alias-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/batch/batchAliasEdit'),
			},
			// Feed Routes
			{
				path: '/fee-list-by-batch',
				name: 'fee-list-by-batch',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/fee/feeListByBatch'),
			},
			{
				path: '/fee-list',
				name: 'fee-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/fee/feeList'),
			},
			// Exchange Rate Routes
			{
				path: '/exchange-list',
				name: 'exchange-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/payment/exchangeRateList'),
			},
			// Enrollment Routes
			{
				path: '/enrollment-list',
				name: 'enrollment-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/enrollment/enrollmentList'),
			},
			{
				path: '/enrollment-create',
				name: 'enrollment-create',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/enrollment/enrollmentCreate'),
			},
			{
				path: '/enrollment-option',
				name: 'enrollment-option',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/enrollment/enrollmentOption'),
			},
			{
				path: '/enrollment-edit',
				name: 'enrollment-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/enrollment/enrollmentEdit'),
			},
			{
				path: '/enrollment-alias-edit',
				name: 'enrollment-alias-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/enrollment/enrollmentAliasEdit'),
			},
			// Receipt Routes
			{
				path: '/receipt-list',
				name: 'receipt-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/receipt/receiptList'),
			},
			{
				path: '/receipt-create',
				name: 'receipt-create',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/receipt/receiptCreate'),
			},
			{
				path: '/receipt-edit',
				name: 'receipt-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/receipt/receiptEdit'),
			},
			// Report Routes
			{
				path: '/report/receipt',
				name: 'receipt-report-list',
				component: () => import('../views/report/receiptList'),
			},
			{
				path: '/report/enrollment',
				name: 'enrollment-report-list',
				component: () => import('../views/report/enrollmentList'),
			},
			// Payment Type Routes
			{
				path: '/payment-list',
				name: 'payment-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/payment/paymentList'),
			},
			{
				path: '/bank-list',
				name: 'bank-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/payment/bankList'),
			},
		]
	},

	{
		path: '/*',
		redirect: '/dashboard'
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})


export default router
// Global navigation guard to prevent access to login page if authenticated
router.beforeEach((to, from, next) => {
	const token = localStorage.getItem('token');
	if (to.path === '/login' && token) {
		// If token exists, redirect to dashboard
		next('/dashboard');
	} else {
		next();
	}
});